import GenericDB from './generic-db';

export default class ClientCoveragesDB extends GenericDB {
  constructor() {
    super('clientCoverages');
  }
}
